export default function XIcon() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.9617 1H23.6405L15.5631 10.3358L25 23H17.5945L11.7964 15.3041L5.15861 23H1.47984L10.037 13.0148L1 1H8.58947L13.8277 8.03026L19.9617 1ZM18.6741 20.8081H20.7134L7.51783 3.1107H5.32656L18.6741 20.8081Z" fill="currentColor" />
        </svg>

    )
}